const authorizeConstants = {
  ACCESS_TOKEN_KEY: 'ws_access_token',
  REFRESH_TOKEN_KEY: 'ws_refresh_token',
  ERROR_TYPE: {
    REFRESH_TOKEN_FAULT: '0001',
    SERVER_ERROR: '0002',
    NONE_REFRESH_TOKEN: '0003'
  }
}

export default authorizeConstants
